import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { User } from 'stream-chat';
import { Chat, useCreateChatClient } from 'stream-chat-react';

import itrackStreamI18n from './StreamTranslation';
import { getChatToken } from './StreamChatToken';

const apiKey = import.meta.env.VITE_GETSTREAMIO_APIKEY;

export default function StreamChatPhoneLayer({
  userId,
  userName,
  children,
}: {
  userId: string;
  userName: string;
  children: ReactElement;
}) {
  const { t, i18n } = useTranslation();

  const user: User = {
    id: userId,
    name: userName,
    image: `https://getstream.io/random_png/?name=${userName}`,
  };

  const client = useCreateChatClient({
    apiKey,
    tokenOrProvider: () => getChatToken(userId, apiKey),
    userData: user,
  });

  if (!client) return children;
  const streami18n = itrackStreamI18n(t, i18n);

  return (
    <Chat client={client} i18nInstance={streami18n}>
      {children}
    </Chat>
  );
}
